type LoaderArgs = {
  src: string;
  width: number;
  quality?: number;
};

export const normalizeNextImageSrc = (src: string): string => {
  if (src.startsWith('//')) {
    return `https:${src}`;
  }

  return src;
};

const withQuery = (src: string, params: Record<string, string>): string => {
  const url = new URL(src);

  for (const [key, value] of Object.entries(params)) {
    url.searchParams.set(key, value);
  }

  return url.toString();
};

export default function nextImageLoader({ src, width, quality }: LoaderArgs): string {
  const normalizedSrc = normalizeNextImageSrc(src);

  if (normalizedSrc.startsWith('https://images.ctfassets.net/')) {
    return withQuery(normalizedSrc, {
      w: String(width),
      q: String(quality ?? 75),
    });
  }

  return normalizedSrc;
}
